import { AxiosResponse } from 'axios';
import deviceAxios from '../../../../utils/axios/device.axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import { PaginatedTransactions } from '../../../../interfaces/transactions/pagiantedStore.type';

const tryToFetchTransactions = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
	status?: string,
): Promise<AxiosResponse<PaginatedTransactions>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions?page=${pageNumber}&size=${pageSize}&search=${filters}&status=${status || ''}`
        : `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions?page=${pageNumber}&size=${pageSize}&status=${status || ''}`;
    return deviceAxios.put<PaginatedTransactions>(url, data);
};


const tryToFetchUnreconciledTransactions = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedTransactions>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions/availability-matching?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions/availability-matching?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedTransactions>(url, data);
};

const tryToFetchAllTransactions = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions/export-csv`
    return deviceAxios.post(url, data);
};

const tryToFetchTransactionFilters = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/recon-analytics/dynamic-filters`
    return deviceAxios.put(url, data);
};

const tryToExportTransactionReport = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/produce-output-report`
    return deviceAxios.put(url, data);
};

const tryToReviewTransaction = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/credit-card-transactions/update`
    return deviceAxios.put(url, data);
};

const tryToFetchMonthlyBank = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/layers-report`
    return deviceAxios.put(url, data);
};

const tryToFetchTransactionsRuns = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
	status?: string
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/recon-analytics/filters?page=${pageNumber}&size=${pageSize}&search=${filters}&status=${status}`
        : `${DEVICE_INFO_API_URL}/recon-analytics/filters?page=${pageNumber}&size=${pageSize}&status=${status}`;
    return deviceAxios.get<any>(url);
};

const tryToUploadManualTransaction = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/upload-manual-transactions`
    return deviceAxios.post(url, data);
};


export const TransactionsService = {
    tryToFetchUnreconciledTransactions,
    tryToFetchTransactions,
    tryToReviewTransaction,
    tryToFetchAllTransactions,
    tryToFetchTransactionsRuns,
    tryToExportTransactionReport,
    tryToFetchTransactionFilters,
    tryToFetchMonthlyBank,
	tryToUploadManualTransaction
};